"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../../base"));
var employee_1 = tslib_1.__importDefault(require("../../system/employee"));
var _1 = tslib_1.__importDefault(require("."));
var PayrollCommentResource = /** @class */ (function (_super) {
    tslib_1.__extends(PayrollCommentResource, _super);
    function PayrollCommentResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PayrollCommentResource.endpoint = '/payrollcomments';
    PayrollCommentResource.MODEL_NAME = 'payrollcomment';
    PayrollCommentResource.related = {
        payroll: _1.default,
        employee: employee_1.default,
    };
    return PayrollCommentResource;
}(base_1.default));
exports.default = PayrollCommentResource;
//# sourceMappingURL=payrollcomment.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/pr/payrollcomment.js
// module id = 7k7L
// module chunks = 0